export const videos = {
  LoadingVideo: "video/Loading_BG.webm",
  MainMenuVideo: "video/Main_Menu_BG.webm",
};

export const images = {
  GameLogo: "img/UI/Game_Logo.webp",
  BlipLoadingBackground: "img/UI/Blip-Loading.webp",
  BrainrotLoadingBackground: "img/UI/Brainrot-Loading.webp",
  LoadingBackground: "img/UI/Loading_BG.webp",
  MainMenuBackground: "img/UI/Main_Menu_BG.webp",
  MainMenuBackgroundMobile:"img/UI/Mobile_Background.webp",
  BotSelectionBackground: "img/UI/Bot_Selection_BG.webp",
  AddBotIcon: "img/UI/Add_Bot.webp",
  RemoveBotIcon: "img/UI/Remove_Bot.webp",
  WhiteTickIcon: "img/UI/White_Tick.webp",
  AIBotIcon: "img/UI/AI_Bot_Icon.webp",
  GoBackIcon: "img/UI/Go_Back_Icon.webp",
  LeftArrowIcon: "img/UI/Left_Arrow.webp",
  RightArrowIcon: "img/UI/Right_Arrow.webp",
  TilesBackground: "img/UI/Tiles.webp",
  AddAIPlayersButtonImage: "img/UI/Add_AI_Players.webp",
  InviteFriendsButtonImage: "img/UI/Invite_Friends.webp",
  BotSelectionCard: "img/UI/Bot_Selection_Card.webp",
  ClosePopupIcon: "img/UI/Close_Popup.webp",
  PurchaseButtonIcon: "img/UI/Purchase_Button.webp",
  PurchasedIcon: "img/UI/Purchased.webp",
  PopupButton: "img/UI/Popup_Button.webp",
  BundlePlaceholder: "img/UI/bundle.webp",
  DiscordIcon: "img/UI/Discord_Icon.webp",
  LoginWithDiscord: "img/UI/Login_With_Discord.webp",
  PlayAsGuest: "img/UI/PlayAsGuest.webp",
  BrainImage: "img/UI/brains.webp",
  AllAccessTrialIcon: "img/UI/All_Access_Trial.webp",
  GameConfigBackground: "img/UI/Config_BG.webp",
  ConfigIcon: "img/UI/Config_Icon.webp",
  BlackLeftArrowIcon: "img/UI/Black_Left_Arrow.webp",
  BlackTickIcon: "img/UI/Black_Tick.webp",
  CheckboxIcon: "img/UI/Checkbox_Icon.webp",
  HowToPlayTutorial1: "img/Tutorials/Tutorial_1.webp",
  HowToPlayTutorial2: "img/Tutorials/Tutorial_2.webp",
  HowToPlayTutorial3: "img/Tutorials/Tutorial_3.webp",
  ButtonIcon: "img/UI/Button.webp",
  Transition: "img/UI/Transition.webp",
  WYLDScreen: "img/UI/WYLD_Screen.webp",
  WYLDIdle: "img/UI/WYLD_Idle.png",
  WYLDTalk: "img/UI/WYLD_Talk.png",
  WYLDLaugh: "img/UI/WYLD_Laugh.png",
  LockIcon: "img/UI/Lock_Icon.webp",
};
